export default __webpack_public_path__ + "static/media/correct.ffe3d80c.png";